module.exports = __webpack_public_path__ + "img/bg08.e8ce4022.png";